export const POPSKULLY_ADDRESS = '0x1b60B6daA371F5066bd8C1DC032627bf1f4E95df';
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';